import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeGroupRegular from './envelope-group-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeGroupRegular {...validProps} />;
}

SvgComponent.iconName = 'envelope-group-regular';

export const EnvelopeGroupRegularIcon = svgIconWrapper(SvgComponent);
